'use strict';

export const LOT_STATUS_OPTIONS = [
	{
		label: 'Available',
		value: 49,
	},
	{
		label: 'Reserved',
		value: 50,
	},
	{
		label: 'Not Reserved',
		value: 51,
	},
	{
		label: 'Sold',
		value: 52,
	},
];

export const SPEC_STATUS_OPTIONS = [
	{
		label: 'Under Construction',
		value: 53,
	},
	{
		label: 'Move-In Ready',
		value: 54,
	},
	{
		label: 'Reserved',
		value: 55,
	},
	{
		label: 'Sold',
		value: 56,
	},
];



// WEBPACK FOOTER //
// ./src/assets/js/constants/LotOptions.js